(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaDetailController', SSPersonaDetailController);

    SSPersonaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSPersona', 'SSProyecto'];

    function SSPersonaDetailController($scope, $rootScope, $stateParams, previousState, entity, SSPersona, SSProyecto) {
        var vm = this;

        vm.sSPersona = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSPersonaUpdate', function(event, result) {
            vm.sSPersona = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
